import type { FaireProductEntity } from "../../entity_types/product";

export const p_fjfkf99sye: FaireProductEntity = {
  token: "p_fjfkf99sye",
  type: "product",
  name: "Lotus Biscoff Topping – Caramelised Biscuit Sauce – 895 ml",
  brandToken: "b_16g27gl0kb",
  brandName: "CHAIMATI",
  imageUrl:
    "https://cdn.faire.com/fastly/4161d48b634a66621cd73896b1b57c0dc984ad2968acc008a089157a530fc727.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e46961188cbb2ec18e2e282ff66b17d3d7c0133e0887735727f9147d29cceef.png",
    "https://cdn.faire.com/fastly/72e47dd57902fffda2f23e4c390951b4a46db4627d47406a3554aaaff28cec09.jpeg",
    "https://cdn.faire.com/fastly/3f6e908dda2fac58582642ad620d92b08a5e81b2396edc1d289339226fb4ae52.jpeg",
    "https://cdn.faire.com/fastly/21caa7f01b66d916c6285d8b159a2989a714cbdae47ed74103a4af98ee0bb406.jpeg",
    "https://cdn.faire.com/fastly/47980b7ac4d981e9aded22b86dab51e69160ec6473faa75b7ec28b67c9c1e19f.jpeg",
    "https://cdn.faire.com/fastly/2f067de11d921426e3710676d8a00d2572287eb7fe1b7d3bce5c8d17a684c762.jpeg",
    "https://cdn.faire.com/fastly/850ca41107ec78db11d49c845b90c7533983628c60ff4f2dbd1e4b76ad203ecd.jpeg",
  ],
  priceDollars: 49.99,
  description:
    "Signature Biscoff flavour - perfect for frappes, lattes, and dessert.\n\nGive your drinks a nostalgic twist with the iconic Lotus Biscoff Topping Sauce. With its spiced caramel flavour and smooth texture, it’s perfect for drizzling over iced chai, frappes, milkshakes, or baked goods. Loved by baristas and dessert chefs worldwide.\n\nIdeal for cafés and restaurants looking to create signature Biscoff-based drinks or desserts. This sauce pairs beautifully with Chaimati Tea Powders and works in both hot and cold recipes.",
  tags: [],
  msrpDollars: 99.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:07.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
